import { CdkAccordionItem } from '@angular/cdk/accordion';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { RouterLinkActive } from '@angular/router';
import { GalaxyListItemComponent } from './list-item.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'glxy-list-nav-item, a[glxy-list-nav-item], button[glxy-list-nav-item]',
  host: {
    '[class.active]': 'isActive()',
    '[class.list-nav-item-default]': 'designVersion() === "default" || !designVersion()',
    '[class.list-nav-item-legacy]': 'designVersion() === "legacy"',
  },
  hostDirectives: [MatRipple],
  imports: [NgTemplateOutlet, MatRippleModule],
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-nav-item.component.scss', './list-item.component.scss'],
})
export class GalaxyListNavItemComponent extends GalaxyListItemComponent {
  private rla = inject(RouterLinkActive, { optional: true });
  private readonly accordionItem = inject(CdkAccordionItem, { optional: true });
  private readonly rlaActive = this.rla?.isActiveChange
    ? toSignal(this.rla.isActiveChange, { initialValue: false })
    : signal(false);

  readonly active = input(false);

  constructor() {
    super();
    effect(() => {
      if (this.accordionItem && this.isActive()) {
        this.accordionItem.expanded = this.isActive();
      }
    });
  }
  protected readonly isActive = computed(() => {
    const active = this.active();
    const rlaActive = this.rlaActive();
    return active || rlaActive;
  });
}
